import React, {useState} from "react";
import GenericTemplate from "../../../templates/GenericTemplate";
import {crasseteditms_path, get_ms_assets_path, crassetcsvuploadms_path,} from "../../../atom/Apollo_links";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {
  APOLLO_SYSTEM_ADMIN,
  APOLLO_GROUP_OPERATOR,
  ApolloUserProfileAuth,
  IsAuthorization
} from "../../../atom/Apollo_Authorization";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge"
import {Link, useParams, useHistory} from "react-router-dom";
import Fab from '@material-ui/core/Fab';
import CardContent from "@material-ui/core/CardContent";
import Tooltip from '@material-ui/core/Tooltip';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card/Card";
import {MUISortOptions, SelectableRows} from "mui-datatables";
import {Backdrop, colors} from "@material-ui/core";
import {AdAsset, AdAssetFormatId, AdAssetLabelFormatId, AdAssetProcessType, MailData} from "./common/AdAssetModel";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import {apollo_useStyles} from "../../../atom/Apollo_styles";
import {ApolloRightDrawerContext, RightDrawer} from "../../../molecule/Apollo_RightDrawer";
import {createMuiTheme} from "@material-ui/core/styles";
import AdAssetsDetail from "./AdAssetsDetail";
import AdAssetsEdit from "./AdAssetsEdit";
import {ApolloAxios} from "../../../atom/Apollo_ApiRequest3";
import {BLANK, MSG, RESULT_KBN} from "./common/CommonConst";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {ApolloDataTable, STORAGE_KEY} from "../../../atom/Apollo_DataTable";
import {Bars} from "react-loader-spinner";
import {CrAssetMsColumns, CsvData} from "../../../common/Apollo_CommonConst";
import {APOLLO_PAGE_ID} from "../../../common/Apollo_LocalStorageSettings";

const AdAssetsList: React.FC = () => {

  // usePrams
  const {accountgroupid, accountid, platformaccountid} = useParams()
  // styles
  const classes = apollo_useStyles();
  const history = useHistory();
  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 16,
    breadId: 1,
    queries: [],
    menu: {
      id: 2,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }
  // thema
  const tableTheme = createMuiTheme({
    palette: {
      primary: {
        main: colors.blue[300],
        light: '#fff',
        contrastText: '#fff',
      },
    },
  });

  // useContext
  const {state: apolloContex} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);

  // useState
  const [adAssets, setAdAssets] = useState<AdAsset[]>([]);
  const [processType, setProcessType] = useState("");
  const [selectAssetId, setSelectAssetId] = useState(0);

  // drawer
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const onHandleButtonClick = (e: any) => {
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    })
    setProcessType(e.currentTarget.id)
  }

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "adAssetId",
    direction: 'desc',
  })
  const [numberOfRows, setNumberOfRows] = useState(5)

  const [updateListCnt, setUpdateListCnt] = useState<number>(0)
  const listReloadFunc = () => {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
    setUpdateListCnt(updateListCnt + 1)
  };

  // useEffect
  React.useEffect(() => {
    setProgress(true);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    });
    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_assets_path}/${platformaccountid}`;
    const fetchData = async () => {
      await ApolloAxios.get(
        url,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${apolloContex.accesstoken}`,
          }
        }
      ).then(response => {
        if (response.data.resultcode === RESULT_KBN.SUCCESS) {
          setAdAssets(response.data.adAssets);
        } else {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `${MSG.ERR_GET_ADASSET}${response?.data?.message ?? BLANK}`
            }
          });
        }
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `${MSG.ERR_GET_ADASSET}${err?.errmsg ?? BLANK}`
          }
        });
      }).finally(() => {
        setProgress(false);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false,
          }
        });
      });
    };
    fetchData();

  }, [updateListCnt]);

  // listColumnConfig
  const imageColumns = [
    {
      name: "adAssetId",
      label: "広告アセットID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "adAssetName",
      label: "広告アセット名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "formatId",
      label: "フォーマットタイプ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (formatId: number) => {
          return (
            formatId === AdAssetFormatId.single ? AdAssetLabelFormatId.single :
              formatId === AdAssetFormatId.custom ? AdAssetLabelFormatId.custom : ""
          )
        },
      },
    },
    {
      name: "mailData",
      label: "プレビュー",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({style: {textAlign: "center"}}),
        customBodyRender: (mailData: MailData) => {
          let imgUrl = ""
          if (mailData.commonItems.formatId === AdAssetFormatId.single) {
            imgUrl = mailData.singleItems.imageItem.imageUrl
          } else if (mailData.commonItems.formatId === AdAssetFormatId.custom) {

            const secArray = mailData.customItems.sectionItems.filter(v => v.imageUrl !== "")
            imgUrl = secArray.length > 0 ? secArray[0].imageUrl : ""
          }
          return (
            <img
              src={imgUrl}
              alt=""
              style={{maxHeight: "80px"}}
            />
          );
        },
      }
    },
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          return (
            <Button
              variant="contained"
              color="primary"
              style={{width: "105px"}}
              id={AdAssetProcessType.preview}
              onClick={((e) => {
                setSelectAssetId(adAssets[dataIndex].adAssetId)
                onHandleButtonClick(e)
              })}
              className={classes.button}
            >
              プレビュー
            </Button>
          );
        }
      }
    },
    {
      name: "creativeIds",
      label: "広告設定",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number[]) => {
          return value?.length > 0 ? "有" : "無"
        },
      },
    },
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          return (
            <Button
              variant="contained"
              color="primary"
              id={AdAssetProcessType.edit}
              onClick={((e) => {
                setSelectAssetId(adAssets[dataIndex].adAssetId)
                onHandleButtonClick(e)
              })}
              className={classes.button}
            >
              編集
            </Button>
          );
        }
      }
    },
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          const isDisplay = IsAuthorization(APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN);
          if (!isDisplay) {
            return "";
          }
          return (
            <Button
              variant="contained"
              color="primary"
              id={AdAssetProcessType.copy}
              onClick={((e) => {
                setSelectAssetId(adAssets[dataIndex].adAssetId)
                onHandleButtonClick(e)
              })}
              className={classes.button}
            >
              複製
            </Button>
          );
        },
      }
    },
  ];

  const selectableRows: SelectableRows = 'none';
  const listOptions = {
    filter: false,
    downloadOptions: {
      filename: `crAssets_mail.csv`,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const csvData = formatCsvData(data, adAssets);
      return "\uFEFF" + buildHead(CrAssetMsColumns) + buildBody(csvData);
    },
    sortOrder: localStorage.getItem(STORAGE_KEY.MS_AD_ASSETS_LIST) ? undefined : sortOrder,
    print: false,
    sort: true,
    search: true,
    selectableRows: selectableRows,
    rowsPerPage: numberOfRows,
    rowsPerPageOptions: [5, 10, 20],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    viewColumns: false,
    storageKey: STORAGE_KEY.MS_AD_ASSETS_LIST,
    apolloPageId: APOLLO_PAGE_ID.AD_ASSET_LIST_MS,
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
    onChangeRowsPerPage: (numberOfRows: number) => setNumberOfRows(numberOfRows),
  }

  const [progress, setProgress] = useState(true);

  // render
  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>
      <RightDrawer>
        <AdAssetsController
          processType={processType}
          accountGrpId={accountgroupid}
          accountId={accountid}
          platformaccountid={platformaccountid}
          assetId={selectAssetId}
          listReloadFunc={listReloadFunc}
        />
      </RightDrawer>
      <CustomizedSnackbars/>
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>
      <Grid container>
        <Grid container item xs={6} justify={"flex-start"}>
          <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
            <Tooltip title="広告アセット新規作成" placement="bottom">
              <Link to={`${crasseteditms_path}${accountgroupid}/${accountid}/${platformaccountid}`}>
                <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
                  <AddIcon/>
                </Fab>
              </Link>
            </Tooltip>
          </ApolloUserProfileAuth>
        </Grid>
        <Grid container item xs={6} justify={"flex-end"}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {history.push(`${crassetcsvuploadms_path}${accountgroupid}/${accountid}/${platformaccountid}`)}}
            className={classes.button}
          >
            広告アセット一括アップロード
          </Button>
        </Grid>
      </Grid>
      <React.Fragment>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Card className={classes.root} square variant="outlined">
              <ApolloDataTable
                title=""
                data={adAssets ? adAssets : []}
                columns={imageColumns}
                options={listOptions}
              />
            </Card>
          </CardContent>
        </Card>
      </React.Fragment>
    </GenericTemplate>
  );
};

const AdAssetsController: React.FC<{ processType: string, accountGrpId: number, accountId: number, platformaccountid: number, assetId: number, listReloadFunc: any }> = ({
                                                                                                                                                                           processType,
                                                                                                                                                                           accountGrpId,
                                                                                                                                                                           platformaccountid,
                                                                                                                                                                           accountId,
                                                                                                                                                                           assetId,
                                                                                                                                                                           listReloadFunc,
                                                                                                                                                                         }) => {
  return [AdAssetProcessType.edit, AdAssetProcessType.copy].includes(processType) ?
    <AdAssetsEdit processType={processType} accountGrpId={accountGrpId} accountId={accountId}
                  platformaccountid={platformaccountid}
                  assetId={assetId}
                  listReloadFunc={listReloadFunc}
    /> : processType === AdAssetProcessType.preview ?
      <AdAssetsDetail platformAccountId={platformaccountid} assetId={assetId}/> : <></>
}

export default AdAssetsList;

const formatCsvData = (data: any[], tableData: AdAsset[]): CsvData[] => {
  const dataList: CsvData[] = [];
  data?.map((v: { index: any, data: any[] }) => {
      if (!v.data || v.data.length === 0) return;
      const values = tableData.filter((td: any) => td.adAssetId === v.data[0]);
      if (!values || values.length === 0) return;
      const d = values[0];
      let imgUrl = ""
      if (d.mailData.commonItems.formatId === AdAssetFormatId.single) {
        imgUrl = d.mailData.singleItems.imageItem.imageUrl
      } else if (d.mailData.commonItems.formatId === AdAssetFormatId.custom) {
        const secArray = d.mailData.customItems.sectionItems.filter(v => v.imageUrl !== "")
        imgUrl = secArray.length > 0 ? secArray[0].imageUrl : ""
      }
      const list: CsvData = {
        index: v.index,
        data: [
          d.adAssetId,
          d.adAssetName,
          d.formatId === AdAssetFormatId.single ? AdAssetLabelFormatId.single :
            d.formatId === AdAssetFormatId.custom ? AdAssetLabelFormatId.custom : "",
          d.creativeIds.length > 0 ? "有" : "無",
        ],
      };
      dataList.push(list);
    }
  );
  return dataList;
}
